import { Moment } from "moment";
import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../../enums/ajaxResult";
import { useApi } from "../../../../../useApi";

export function useCreateLease(boxId: number) {
    const { leaseApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const createLease = useCallback((
        ownerId: number,
        leaseStartDate: Moment,
        leaseEndDate: Moment | null,
        onSuccess: () => void,
    ) => {
        setLoading(true);
        leaseApi
            .postOne({
                boxId,
                userIds: [ownerId],
                endDate: leaseEndDate && leaseEndDate.toISOString(),
                startDate: leaseStartDate.toISOString()
            })
            .then((r) => {
                if (r.result === AjaxResult.Success) {
                    enqueueSnackbar("New lease created!", { variant: "success" });
                    onSuccess();
                } else {
                    enqueueSnackbar("Failed to create new lease!", { variant: "error" });
                }
                setLoading(false);
            });
    }, [leaseApi, boxId, enqueueSnackbar]);

    return { createLease, loading };
}
